// extracted by mini-css-extract-plugin
export default {"content":"QuestionContent_content__aNslV"};